import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentConfig } from './environment-config';

@Injectable()
export class CustomHeadersInterceptor implements HttpInterceptor {

    private static readonly CONTENT_TYPE: string = 'Content-Type';
    private static readonly ACCEPT: string = 'Accept';

    constructor(private env: EnvironmentConfig) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let headers = req.headers;

        /* Setze Content-Type und Accept falls sie noch keinen Wert haben. Wenn der Wert '' ist, dann
         * wird der Header gelöscht. Das ist z.B. wichtig beim Dateiupload wo der Browser den Content-Type
         * auf multipart/form-data setzt, aber nur wenn kein anderer Content-Type gesetzt ist. '' dient hier also
         * als Markierung zur Löschung.
         */
        headers = this.setOrDelete(headers, CustomHeadersInterceptor.CONTENT_TYPE, 'application/json;charset=UTF-8', headers.append);
        headers = this.setOrDelete(headers, CustomHeadersInterceptor.ACCEPT, '*/*', headers.set);

        // Wenn in der index.html ein testUser gesetzt ist und wir im dev-Modus unterwegs sind, dann wird Basic-Auth aktiviert.
        if (this.env.isDev() && typeof this.env.testUser !== 'undefined') {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.env.testUser + ':' + this.env.testPassword));
        }

        return next.handle(req.clone({ headers }));
    }

    /**
     * Setzt bzw. appended einen Headerwert falls der Header noch keinen Wert hat. Wenn der Wert '' ist, dann
     * wird der Header gelöscht.
     *
     * @param headers die HttpHeaders
     * @param headerName der Name des Headers
     * @param value der zu setzende Wert
     * @param setter der setter, z.B. HttpHeaders::set oder HttpHeaders::append
     */
    private setOrDelete(headers: HttpHeaders, headerName: string, value: string,
                        setter: (name: string, value: string | string[]) => HttpHeaders) {
        const headerValue = headers.get(headerName);
        if (headerValue === null || headerValue === undefined) {
            return setter.call(headers, headerName, value);
        } else if (headerValue === '') {
            return headers.delete(headerName);
        }
        return headers;
    }
}
